export const theme = {
  primaryColor: '#292F4C',
  secondaryColor: '#133774',
  dangerColor: '#F44336',
  successColor: '#02CD6B',
  warningColor: '#FAAD14',
  infoColor: '#1890FF',
  whiteColor: '#F5F5F5',
  darkColor: '#181B34',
  greyColor: '#F7F9FC',
  lightGreyColor: '#D9D9D9',
  errorColor: '#cc0033',
  lightErrorColor: '#fce4e4',
  cardPadding: '2rem 1.5rem',

  sizes: {
    borderRadius: '2px',
    buttonFontSize: '0.875rem',
    inputFontSize: '1rem',
  },
};
